import { useRef } from "react";
import ExpandIcon from '../../../media/icons/assets_light/outline-message-active.svg';
import MessageIcon from '../../../media/icons/assets_light/outline-message-active.svg';
import AttachmentsIcon from '../../../media/icons/assets_light/outline-action-attach-active.svg';
import CheckListIcon from '../../../media/icons/assets_light/checkListIcon.svg';
import TagIcon from '../../../media/icons/assets_light/outline-management-tag-active.svg';
import FlaggedIcon from '../../../media/icons/assets_dark/flag_red.svg';

import { useDashboard } from "../../../context/DashboardContext";
import { getONLYUSERSDATA } from "../../../Utils/Common";
import { useSelector } from "react-redux";
import moment from "moment";
import SkeletonForTask from "./SkeletonForTask";
import { useNavigate } from "react-router-dom";


export default function FlaggedTasks() {
  const { active_conversation } = useSelector(state => state.message);
  const { loader, pagination, prevloader, flaggedTasks, setPrevLoader, getFlaggedTask } = useDashboard();
  const { allUsers } = useSelector((state) => state.message);
  const containerRef = useRef(null);
  const prevScrollHeight = useRef(0);

  const onScrollTasks = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = containerRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 100) {
      if (!prevloader) {
        if (pagination.totalPages > pagination.page) {
          let container = containerRef.current;
          requestAnimationFrame(() => {
            prevScrollHeight.current = container.scrollHeight;
          });
          setPrevLoader(true);
          getFlaggedTask({ variables: { conversation_id: active_conversation.conversation_id, page: pagination.page + 1 } });
          // setPage(prevPage => prevPage + 1); // Increment page for pagination
        }
      }
    }
  }


  return (
    <div className='!h-[calc(100%-96px)]'>
      <div className="bg-white dark:bg-surface-dark h-full overflow-y-auto" ref={containerRef} onScroll={onScrollTasks}>
        {/* Loader: show only when flaggedTasks is undefined or null, not empty array */}
        {loader ? (
          <SkeletonForTask count={20} />
        ) : flaggedTasks.length > 0 ? (
          flaggedTasks.map((task, idx) => (
            <TaskCard key={idx} {...task} allUsers={allUsers} />
          ))
        ) : (
          <p className="text-center text-gray-500 dark:text-white mt-40">No flagged tasks found</p>
        )}
        {prevloader && (
          <SkeletonForTask count={20} />
        )}
      </div>
    </div>
  );
}

function TaskCard({ _id, task_title, conversation_name, assign_to, created_at, highlight, discussion, files, checklists, key_words, allUsers }) {
  // const [checked, setChecked] = useState(false);
  const navigate = useNavigate();

  const viewTaskDetails = (item) => {
    // Logic to view task details can be implemented here
    navigate(`tasks/${_id}`)
  }

  return (
    <div onClick={() => viewTaskDetails()} className="mx-3 my-3 max-h-[150px] rounded-lg dark:bg-[rgba(255,255,255,0.05)] shadow-sm border border-border-primary  p-[12px] flex flex-col justify-between last:mb-3">
      {/* Left */}

      <div >
        <div className="flex items-center gap-2 mb-2">
          {/* <div className="flex items-center"> */}
            {/* <input type="checkbox" id={`task-${task_title}`} checked={checked} onChange={() => setChecked(!checked)}
              className="hidden"
            /> */}
            {/* <label htmlFor={`task-${task_title}`} className="checkboxForSignup flex items-center gap-2 cursor-pointer text-text-body" >
              <span className={`w-4 h-4 rounded border ${checked ? "border-[#636E82]" : "border-gray-400"} flex items-center justify-center transition-all ${checked ? "bg-[#fff]" : "bg-white"}`} >
                {checked && (
                  <svg className="w-3 h-3 text-[#636E82]" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24" >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </span>
            </label> */}
          {/* </div> */}
          <h3 className="text-[16px] font-normal text-text-headings dark:text-white">{task_title}</h3>
          <div className="ml-auto">
            <div
              className="relative top-[0px] right-[0px] w-[24px] h-[24px] bg-[#636E82] dark:bg-white hover:bg-btn-hover pointer-events-none transition-colors"
              style={{
                WebkitMaskImage: `url(${ExpandIcon})`,
                WebkitMaskRepeat: 'no-repeat',
                WebkitMaskPosition: 'center',
                WebkitMaskSize: 'contain',
                maskImage: `url(${ExpandIcon})`,
                maskRepeat: 'no-repeat',
                maskPosition: 'center',
                maskSize: 'contain',
              }}
            />
          </div>
        </div>
        <div className="pl-0">
          {conversation_name && <p className="text-xs text-gray-600 dark:text-white mt-1">{conversation_name}</p>}
          {assign_to && (
            <p className="text-xs text-gray-600 dark:text-white mt-1">
              Assigned to: <span className="font-medium text-[#2440BD] dark:text-white">{assign_to?.length > 0 ? getONLYUSERSDATA(allUsers, assign_to, 'name') : 'N/A'}</span>
            </p>
          )}
        </div>
      </div>


      {/* Right */}
      <div className="flex items-center justify-between mt-[20px] h-full">
        <div
          className={`text-[14px] pr-2 rounded-full font-medium ${highlight ? "text-text-error dark:text-white" : "text-grey-500 dark:text-white"}`}
        >
          {moment(created_at).format('MMMM DD, YYYY')}
        </div>

        <div className="flex flex-wrap gap-2 text-gray-500 text-xs ">
          {discussion.length > 0 &&
            <div className="flex items-center gap-[2px]">
              <div
                className="relative top-[0px] right-[0px] w-[15px] h-[15px] bg-[#636E82] dark:bg-white hover:bg-btn-hover pointer-events-none transition-colors"
                style={{
                  WebkitMaskImage: `url(${MessageIcon})`,
                  WebkitMaskRepeat: 'no-repeat',
                  WebkitMaskPosition: 'center',
                  WebkitMaskSize: 'contain',
                  maskImage: `url(${MessageIcon})`,
                  maskRepeat: 'no-repeat',
                  maskPosition: 'center',
                  maskSize: 'contain',
                }}
              />

              <span className="text-grey-500 dark:text-white">({discussion.length})</span>
            </div>
          }
          {files.length > 0 &&
            <div className="flex items-center gap-[2px]">
              <div
                className="relative top-[0px] right-[0px] w-[15px] h-[15px] bg-[#636E82] dark:bg-white hover:bg-btn-hover pointer-events-none transition-colors"
                style={{
                  WebkitMaskImage: `url(${AttachmentsIcon})`,
                  WebkitMaskRepeat: 'no-repeat',
                  WebkitMaskPosition: 'center',
                  WebkitMaskSize: 'contain',
                  maskImage: `url(${AttachmentsIcon})`,
                  maskRepeat: 'no-repeat',
                  maskPosition: 'center',
                  maskSize: 'contain',
                }}
              />

              <span className="text-grey-500 dark:text-white">({files.length})</span>
            </div>
          }
          {checklists.length > 0 &&
            <div className="flex items-center gap-[2px]">
              <div
                className="relative top-[0px] right-[0px] w-[15px] h-[15px] bg-[#5929AB] dark:bg-white hover:bg-btn-hover pointer-events-none transition-colors"
                style={{
                  WebkitMaskImage: `url(${CheckListIcon})`,
                  WebkitMaskRepeat: 'no-repeat',
                  WebkitMaskPosition: 'center',
                  WebkitMaskSize: 'contain',
                  maskImage: `url(${CheckListIcon})`,
                  maskRepeat: 'no-repeat',
                  maskPosition: 'center',
                  maskSize: 'contain',
                }}
              />

              <span className="text-[#5929AB] dark:text-white">({checklists.length})</span>
            </div>
          }
          {key_words.length > 0 &&
            <div className="flex items-center gap-[2px]">
              <div
                className="relative top-[0px] right-[0px] w-[15px] h-[15px] bg-[#636E82] dark:bg-white hover:bg-btn-hover pointer-events-none transition-colors"
                style={{
                  WebkitMaskImage: `url(${TagIcon})`,
                  WebkitMaskRepeat: 'no-repeat',
                  WebkitMaskPosition: 'center',
                  WebkitMaskSize: 'contain',
                  maskImage: `url(${TagIcon})`,
                  maskRepeat: 'no-repeat',
                  maskPosition: 'center',
                  maskSize: 'contain',
                }}
              />

              <span className="text-[#636E82] dark:text-white">({key_words.length})</span>
            </div>
          }

        </div>
        <div className="flex items-center">
          <div
            className="relative top-[0px] right-[0px] w-[22px] h-[22px] bg-[#5929AB] dark:bg-white hover:bg-btn-hover pointer-events-none transition-colors"
            style={{
              WebkitMaskImage: `url(${FlaggedIcon})`,
              WebkitMaskRepeat: 'no-repeat',
              WebkitMaskPosition: 'center',
              WebkitMaskSize: 'contain',
              maskImage: `url(${FlaggedIcon})`,
              maskRepeat: 'no-repeat',
              maskPosition: 'center',
              maskSize: 'contain',
            }}
          />
        </div>

      </div>
    </div>
  );
}